<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="box centered">
          <a @click.prevent="reimport">Reimport Fixtures</a>
          <b-loading :active="reimporting"></b-loading>
        </div>
      </div>
      <div class="column" v-if="['Football', 'Rugby'].indexOf(feedType) !== -1">
        <div class="box centered">
          <a @click.prevent="flush">Flush Old Fixtures</a>
          <b-loading :active="reimporting"></b-loading>
        </div>
      </div>
    </div>

    <div v-if="filteredFixtures">
      <div class="field">
        <b-input placeholder="Search" v-model="query"></b-input>
      </div>
      <div class="columns is-multiline">
        <div class="column is-one-third" :key="fixture.id" v-for="fixture in filteredFixtures">
          <router-link
            class="card has-pointer-cursor"
            tag="div"
            :to="`/feeds/${feedId}/fixtures/${fixture.id}/view`"
          >
            <div class="card-content">
              <p class="title is-5">{{fixture.name}}</p>
              <p class="subtitle is-6">
                {{fixture.location}}
                <br>
                {{fixture.status_name || "Unknown Status"}}
              </p>
              <hr>
              <div class="columns" v-if="fixture.home_team || fixture.away_team">
                <div class="column centered" v-if="fixture.home_team">
                  <img
                    class="team-logo"
                    :src="fixture.home_team.image_url"
                    :alt="fixture.home_team.short_name"
                  >
                  <br>
                  <span class="team-name">{{fixture.home_team.short_name || fixture.home_team.name}}</span>
                </div>
                <div class="column centered" v-if="fixture.away_team">
                  <img
                    class="team-logo"
                    :src="fixture.away_team.image_url"
                    :alt="fixture.away_team.short_name"
                  >
                  <br>
                  <span class="team-name">{{fixture.away_team.short_name || fixture.away_team.name}}</span>
                </div>
              </div>
              <div class="content">
                <span>{{fixture.starts_at}}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import {
  GET_FEED_FIXTURES,
  REIMPORT_FEED_CONTENT,
  FLUSH_FEED_FIXTURES
} from "@/store/actions";

const STATUS_ALL = "All";
const STATUS_TODAY = "Today";
const STATUS_RESULT = "Result";
const STATUS_COMING_UP = "Coming Up";

export default {
  name: "feed-fixtures",
  components: {
    Loading
  },
  data() {
    return {
      query: "",
      reimporting: false
    };
  },
  mounted() {
    if (!this.fixtures || this.fixtures.length <= 0) {
      this.$store.dispatch(GET_FEED_FIXTURES, { feedId: this.feedId } );
    }
  },
  computed: {
    fixtures() {
      return this.$store.state.feed.fixtures;
    },
    feedId() {
      return this.$route.params.id;
    },
    feedType() {
      return this.$store.state.feed.item
        ? this.$store.state.feed.item.type
        : null;
    },
    status() {
      let { status } = this.$route.params;
      if (!status) return STATUS_ALL;
      else if (status === "today") return STATUS_TODAY;
      else if (status === "comingup") return STATUS_COMING_UP;
      else if (status === "results") return STATUS_RESULT;
    },
    filteredFixtures() {
      if (!this.fixtures) {
        return null;
      }

      let { fixtures } = this;
      let fixtureData = null;

      if (this.status === STATUS_ALL) {
        fixtureData = fixtures;
      } else if (this.status === STATUS_TODAY) {
        fixtureData = fixtures.filter(x => {
          return x.tags.indexOf("today") !== -1;
        });
      } else if (this.status === STATUS_COMING_UP) {
        fixtureData = fixtures.filter(x => {
          return x.status_name === STATUS_COMING_UP;
        });
      } else if (this.status === STATUS_RESULT) {
        fixtureData = fixtures.filter(x => {
          return x.status_name === STATUS_RESULT;
        });
      }

      if (this.query && this.query.trim().length > 0) {
        let lowercaseQuery = this.query.trim().toLowerCase();
        fixtureData = fixtureData.filter(x => {
          return (
            x.name.toLowerCase().indexOf(lowercaseQuery) > -1 ||
            x.location.toLowerCase().indexOf(lowercaseQuery) > -1
          );
        });
      }

      return fixtureData;
    }
  },
  watch: {},
  methods: {
    reimport() {
      this.reimporting = true;
      this.$store
        .dispatch(REIMPORT_FEED_CONTENT, {
          id: this.feedId,
          reimport_type: "fixtures"
        })
        .then(res => {
          if (res && res.status === 200) {
            this.$success(`Fixtures were reimported`);
          }
        })
        .finally(() => {
          this.reimporting = false;
        });
    },
    flush() {
      this.reimporting = true;
      this.$store
        .dispatch(FLUSH_FEED_FIXTURES, this.feedId)
        .then(res => {
          if (res && res.status === 200) {
            this.$success(`Fixtures were flushed`);
          }
        })
        .finally(() => {
          this.reimporting = false;
        });
    }
  }
};
</script>

<style scoped>
.team-logo {
  width: 48px;
  height: 48px;
}
.team-name {
  font-size: 13px;
}
.centered {
  text-align: center;
}
.has-pointer-cursor {
  cursor: pointer;
}
</style>
